import { useState } from 'react'
import { useDispatch } from 'react-redux'
import { Link } from 'react-router-dom'
import { setResponsiveSearch } from 'src/ReduxToolkit/Reducers/LayoutSlice'
import { SVG } from '../../../AbstractElements'
import { MenuItem, SearchSuggestionListType } from '../../../Type/Layout/Sidebar'

const SearchSuggestionList = ({ searchedArray, setSearchedWord }: SearchSuggestionListType) => {
  const [activeTitle, setActiveTitle] = useState(""); 
   const dispatch = useDispatch();
  const handleLinkClick = (title: string) => {
    dispatch(setResponsiveSearch());
    setSearchedWord("");
    setActiveTitle(title);
  };
  return (
    <>
       {searchedArray?.map((item: MenuItem, index: number) => (
        <div className={`ProfileCard u-cf ${activeTitle === item.title ? "active" : ""}`} key={index}>
          <div className="ProfileCard-details">
            <div className="ProfileCard-realName">
              <Link className="realname  w-auto d-flex justify-content-start gap-2" to={`${item.path}`} onClick={() => handleLinkClick(item.title)}>
                <SVG iconId={`stroke-${item.icon}`} />
                {item.title}
              </Link>
            </div>
          </div>
        </div>
      ))}
      {!searchedArray.length && <p>Opps!! There are no result found.</p>}
    </>
  )
}

export default SearchSuggestionList